import React, { useState, forwardRef, useEffect, useRef, useMemo } from "react";
import FetchData, { CreateEntry, UpdateEntry, GetList, GetOne } from '../../providers/dataProvider';
import { CheckNull, CurrencyConvertion, calculateNetPrice } from "../../utils/Validate";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import UnSaveModel from "../../components/common/UnSaveModel";
import urls from "../../constants";
import { Configuration } from "../../components/quotation/Configurations";
import { useListPriceCalculation } from "../../hooks/useListPriceCalculation";
import { useMultiplier } from "../../hooks/useMultiplier";
import { PriceRecalculate } from "./PriceRecalculate";
import { ProductImportFile } from "./ProductImportFile";
import Loader from "../common/Loader";
import { useVariantOptions } from "../../components/quotation/SizeSelectField";
import { ProductPreviewPanel } from "../../components/quotation/ProductPreviewPanel.js";
import { ProductMarkWorkspaceHeader } from "./ProductMarkWorkspaceHeader";
import { ProductSizeGrid, isVariantHidden } from "./ProductSizeGrid";

const COLUMN_VISIBILITY_STORAGE_KEY = "pathfinder.productMark.columnVisibility";

const getColumnVisibilityStorageKey = (userId, productTab) => {
    const productGroupId = productTab?.id?.productGroupId ?? "no-group";
    const productSubGroupId = productTab?.id?.productSubGroupId ?? "no-sub-group";
    const productId = productTab?.id?.id ?? "no-product";

    return [
        COLUMN_VISIBILITY_STORAGE_KEY,
        userId || "anonymous",
        productGroupId,
        productSubGroupId,
        productId,
    ].join(":");
};

const readStoredVisibleColumns = (storageKey) => {
    try {
        const rawValue = sessionStorage.getItem(storageKey);
        if (!rawValue) return null;

        const parsedValue = JSON.parse(rawValue);
        if (!parsedValue || !Array.isArray(parsedValue.columns)) return null;

        return parsedValue;
    } catch (error) {
        return null;
    }
};

const writeStoredVisibleColumns = (storageKey, payload) => {
    try {
        sessionStorage.setItem(storageKey, JSON.stringify(payload));
    } catch (error) {
    }
};

const WORKSPACE_SNAPSHOT_PRICE_VARIANT_IDS = new Set([
    ...(urls?.LIST_PRICE_CONSTANT || []),
    ...(urls?.NET_LIST_PRICE_CONSTANT || []),
    ...(urls?.UNIT_PRICE_CONSTANT || []),
    ...(urls?.NET_UNIT_PRICE_CONSTANT || []),
]);

const toSnapshotValue = (value) => {
    if (value === null || value === undefined) return "";
    return String(value);
};

const buildWorkspaceSnapshot = (productConfig, configSetting, addProduct, variantsArray) => {
    const productName = productConfig?.productName || {};

    const configurationSnapshot = (configSetting || [])
        .map((item) => ({
            attributeId: item?.attributeId ?? "",
            valueName: toSnapshotValue(item?.valueName),
            specialValue: toSnapshotValue(item?.specialValue),
        }))
        .sort((left, right) => Number(left.attributeId) - Number(right.attributeId));

    const rowSnapshot = (addProduct || []).map((row) => ({
        sid: row?.sid ?? "",
        id: row?.id ?? "",
        quoteProductId: row?.quoteProductId ?? "",
        notes: toSnapshotValue(row?.notes),
        specialDesignRequest: toSnapshotValue(row?.specialDesignRequest),
        sdrCharges: toSnapshotValue(row?.sdrCharges),
        costingToken: toSnapshotValue(row?.costingToken),
        margin: toSnapshotValue(row?.margin),
    }));

    const variantSnapshot = (variantsArray || [])
        .filter((variant) => !WORKSPACE_SNAPSHOT_PRICE_VARIANT_IDS.has(variant?.variantId))
        .map((variant) => ({
            sid: variant?.sid ?? "",
            id: variant?.id ?? "",
            quoteProductItemId: variant?.quoteProductItemId ?? "",
            variantId: variant?.variantId ?? "",
            variantValue: toSnapshotValue(variant?.variantValue),
            inputByUser: Boolean(variant?.inputByUser),
        }));

    return JSON.stringify({
        productId: productName?.productId ?? "",
        productGroupId: productName?.productGroupId ?? "",
        productSubGroupId: productName?.productSubGroupId ?? "",
        configurationSnapshot,
        rowSnapshot,
        variantSnapshot,
    });
};

export const ProductQuotation = ({
    setProductTab,
    ProductTab,
    setProductConfig,
    productConfig,
    productSubmit,
    setProductSubmit,
    values,
    setValues,
    attributes,
    setAttributes,
    configSetting,
    setConfigSetting,
    SaveProductMarkAdd,
    currencyDetail,
}) => {
    const [productVariant, setProductVariant] = useState([]);
    const [sdrOpen, setSDROpen] = useState("hide")
    const [actionMenuOpen, setActionMenuOpen] = useState({})
    const [actionMenuPosition, setActionMenuPosition] = useState({ top: 0, left: 0 })
    const [variantsArray, setvariantsarray] = useState([])
    const [editMarkDetails, setEditMarkDetails] = useState({})
    const [markCreateMessage, setMarkCreateMessage] = useState(null);
    const [productName, setProductName] = useState({});
    const [createMsg, setCreateMsg] = useState(null)
    const [quoteMsg, setQuoteMsg] = useState(null)
    const [quoteDetails, setQuoteDetails] = useState(null)
    const [productValues, setProductValues] = useState(false)
    const [successshow, setSuccessShow] = useState(false)
    const [modalShow, setModalShow] = useState(false);
    const [recalculateModalShow, setRecalculateModalShow] = useState(false);
    const [recalculateLoading, setRecalculateLoading] = useState(false);
    const [recalculate, setRecalculate] = useState(false)
    const [editConfig, setEditConfig] = useState({})
    const [addProduct, setAddProduct] = useState([])
    const [selectedSizeRowSids, setSelectedSizeRowSids] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [marginRangeError, setMarginRangeError] = useState([]);

    const [invalidUnitPrice, setInvalidUnitPrice] = useState([]);
    const [requiredFieldError, setRequiredFieldError] = useState([]);
    const [productMarkDetails, setProductMarkDetails] = useState(null);
    const [salesMultiplier, setSalesMultiplier] = useState({});
    const [productConfigVariant, setProductConfigVariant] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [pendingColumns, setPendingColumns] = useState([]);
    const [attributeDetails, setattributeDetails] = useState([]);
    const [attributeArray, setAttributeArray] = useState([]);
    const [attributeValueArray, setAttributeValueArray] = useState([]);
    const [groupArray, setGroupArray] = useState([]);
    const [lastKey, setLastKey] = useState("");
    const [endcaplist, setEndCapList] = useState(
        [{ label: "None", value: "None" },
        { label: "One Side", value: "One Side" },
        { label: "Both Sides", value: "Both Sides" }])

    const [deleteProduct, setDeleteProduct] = useState(false)
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [showUnsavedModal, setShowUnsavedModal] = useState(false);
    const [pendingSuccessModal, setPendingSuccessModal] = useState(false);
    const [pendingNavigation, setPendingNavigation] = useState(false);
    const [lastMatchedProductId, setLastMatchedProductId] = useState(null);
    const [isEditMarkDetailsLoading, setIsEditMarkDetailsLoading] = useState(false);
    const configurationRef = useRef(null);
    const workspaceSnapshotRef = useRef("");
    const workspaceSnapshotReadyRef = useRef(false);
    const lastConfigurationSignatureRef = useRef("");
    const columnDefaultsSignatureRef = useRef("");
    const addProductRef = useRef([]);
    const pendingSizeFocusRef = useRef(null);
    const pendingSizeFocusFrameRef = useRef(null);
    const maxBlankSizeRows = 2;
    const currentUserId = localStorage.getItem("authidentity");
    const columnVisibilityStorageKey = getColumnVisibilityStorageKey(currentUserId, ProductTab);

    useEffect(() => {
        addProductRef.current = addProduct;
    }, [addProduct]);

    useEffect(() => {
        return () => {
            if (pendingSizeFocusFrameRef.current) {
                cancelAnimationFrame(pendingSizeFocusFrameRef.current);
            }
        };
    }, []);

    useEffect(() => {
        workspaceSnapshotRef.current = "";
        workspaceSnapshotReadyRef.current = false;
    }, [
        ProductTab?.status,
        ProductTab?.id?.id,
        ProductTab?.id?.item?.id,
        ProductTab?.redirectTab,
        ProductTab?.title,
    ]);

    const markWorkspaceSnapshot = () => {
        workspaceSnapshotRef.current = buildWorkspaceSnapshot(
            productConfig,
            configSetting,
            addProduct,
            variantsArray
        );
        workspaceSnapshotReadyRef.current = true;
    };

    useEffect(() => {
        if (workspaceSnapshotReadyRef.current) return;
        if (isEditMarkDetailsLoading) return;
        if (!productConfig?.productName?.productId && !configSetting?.length && !addProduct?.length && !variantsArray?.length) {
            return;
        }

        markWorkspaceSnapshot();
    }, [
        isEditMarkDetailsLoading,
        productConfig?.productName?.productId,
        configSetting,
        addProduct,
        variantsArray,
    ]);
    const AddNewEntry = () => {
        if (ValidEntry() === "error") return;
        AddProduct();
    }
    const { userMultiplier } = useMultiplier();
    const { HandleProductOnChange } = useListPriceCalculation({ variantsArray, setvariantsarray, setSalesMultiplier, AddNewEntry, addProduct, setAddProduct, productConfig, configSetting, setErrorMessage, userMultiplier, lastKey, setLastKey, setHasUnsavedChanges })
    const { data: productVariants } = FetchData("productsvariants", { id: ProductTab?.id?.productGroupId });
    const { data: actuatorLocationData, loading: actuatorLocationLoading } = FetchData("actuatorlocation");
    const { optionsMap, combinations, loading: optionsLoading } = useVariantOptions(productConfig?.productName?.productId);
    const actuatorLocationOptions = Array.isArray(actuatorLocationData)
        ? actuatorLocationData.map((item) => item?.actuatorLocation).filter(Boolean)
        : [];

    const hasMeaningfulValue = (value) => {
        if (value === null || value === undefined) return false;
        return String(value).trim() !== "";
    };

    const isBlankSizeRow = (row, rowVariants = []) => {
        if (!row) return false;

        const rowFields = [
            row?.notes,
            row?.specialDesignRequest,
            row?.sdrCharges,
            row?.costingToken,
            row?.margin,
        ];

        if (rowFields.some(hasMeaningfulValue)) return false;

        return !rowVariants.some((variant) => hasMeaningfulValue(variant?.variantValue));
    };

    const pruneExcessBlankRows = () => {
        const rows = addProductRef.current || [];
        if (rows.length <= maxBlankSizeRows) return;

        const blankRows = rows.filter((row) => {
            const rowVariants = variantsArray.filter((variant) => variant?.sid === row?.sid);
            return isBlankSizeRow(row, rowVariants);
        });

        if (blankRows.length <= maxBlankSizeRows) return;

        const rowsToRemove = blankRows
            .slice(0, blankRows.length - maxBlankSizeRows)
            .map((row) => row?.sid)
            .filter((sid) => sid !== undefined && sid !== null);

        if (rowsToRemove.length === 0) return;

        const sidSet = new Set(rowsToRemove);
        setAddProduct((prev) => prev.filter((row) => !sidSet.has(row?.sid)));
        setvariantsarray((prev) => prev.filter((item) => !sidSet.has(item?.sid)));
        setSelectedSizeRowSids((prev) => prev.filter((sid) => !sidSet.has(sid)));
    };

    const HandleOnChangeMargin = (e, productitem) => {
        const value = e.target.value;

        if (value !== "" && /^-?\d*\.?\d*$/.test(value) === false) return;

        // Validation: margin allowed range is -100 to 99.99
        if (value !== "" && value !== "-") {
            const numValue = Number(value);
            if (numValue < -100 || numValue > 99.99) {
                setMarginRangeError((prev) => {
                    const filtered = prev.filter((err) => err?.sid !== productitem?.sid);
                    return [...filtered, { sid: productitem?.sid, message: "Valid margin -100 to 99.99." }];
                });
                return;
            }
        }

        setMarginRangeError((prev) => prev.filter((err) => err?.sid !== productitem?.sid));

        const index = addProduct.findIndex((i) => i.sid === productitem.sid);
        if (index === -1) return;

        setAddProduct((prev) => {
            const updated = [...prev];
            updated[index] = { ...updated[index], margin: value };
            return updated;
        });
        setHasUnsavedChanges(true);

        const marginValue =
            value === "" || value === "-" || isNaN(Number(value)) ? 0 : Number(value);

        const rowVariants = variantsArray.filter((v) => v.sid === productitem.sid);

        const listPriceItem = rowVariants.find((v) => urls?.LIST_PRICE_CONSTANT?.includes(v.variantId));
        const actuatorCostItem = rowVariants.find((v) => urls?.ACTUATOR_COST_CONSTANT?.includes(v.variantId));
        const quantityItem = rowVariants.find((v) => urls?.QUANTITY_CONSTANT?.includes(v.variantId));

        const listPriceVal = Number(listPriceItem?.variantValue) || 0;
        const actuatorCostVal = Number(actuatorCostItem?.variantValue) || 0;
        const quantity = Number(quantityItem?.variantValue) || 1;

        let basePrice = listPriceVal + actuatorCostVal;

        if (basePrice <= 0) {
            const unitPriceItem = rowVariants.find((v) => urls?.UNIT_PRICE_CONSTANT?.includes(v.variantId));
            basePrice = Number(unitPriceItem?.variantValue) || 0;
        }

        if (basePrice <= 0) return;

        const newTotal = calculateNetPrice({
            listPrice: basePrice * quantity,
            margin: marginValue,
        });
        const nextPrice = Number.isFinite(Number(newTotal)) ? Number(newTotal).toFixed(2) : "0.00";

        const priceVariantIds = new Set([
            ...(urls?.NET_LIST_PRICE_CONSTANT || []),
            ...(urls?.NET_UNIT_PRICE_CONSTANT || []),
        ]);

        setvariantsarray((prev) =>
            prev.map((variant) =>
                variant.sid === productitem.sid && priceVariantIds.has(variant.variantId)
                    ? { ...variant, variantValue: nextPrice }
                    : variant
            )
        );
    };
    useEffect(() => {
        if (productVariants) {
            if (productVariants?.length > 0 && productVariant?.length <= 0) {

                const subGroupId = ProductTab?.status === "editmark"
                    ? editMarkDetails?.data?.[0]?.productSubGroupId
                    : ProductTab?.id?.productSubGroupId

                if (!subGroupId && ProductTab?.status === "editmark") return;
                const checkGroupVariant = productVariants?.filter((item) => item?.productSubGroupId === subGroupId && item?.isActive === true)
                setProductVariant(checkGroupVariant?.length > 0 ? checkGroupVariant : productVariants?.filter((item) => item?.isActive === true && (item?.productSubGroupId === 0 || item?.productSubGroupId === null)))
                setProductConfigVariant(checkGroupVariant?.length > 0 ? checkGroupVariant : productVariants?.filter((item) => item?.isActive === true && (item?.productSubGroupId === 0 || item?.productSubGroupId === null)))
            }
        }
    }, [productVariants, editMarkDetails])

    useEffect(() => {
        setConfigSetting([]);
        setProductConfig({});
        setEditConfig({});
        setLastMatchedProductId(null);
        if (ProductTab?.status === "editmark") {
            setIsEditMarkDetailsLoading(true);
            GetList("productmark", { id: ProductTab?.id?.item?.id }, (response) => {
                setEditMarkDetails(response);
            })
            return;
        }

        setEditMarkDetails({});
        setIsEditMarkDetailsLoading(false);
    }, [ProductTab])


    useEffect(() => {
        if (editMarkDetails && productVariant.length > 0 && attributeArray?.length > 0) {
            let addProductArray = [];
            let productVariantsArray = [];
            if (editMarkDetails?.data?.length > 0 && configSetting?.length <= 0 && !productConfig?.productName?.productName) {

                editMarkDetails?.data[0]?.productItems?.map((prodItem, prodIndex) => {
                    addProductArray.push({
                        sid: (prodIndex * 1) + 1,
                        id: prodItem?.id,
                        quoteProductId: prodItem?.quoteProductId,
                        notes: prodItem?.notes,
                        specialDesignRequest: prodItem?.specialDesignRequest,
                        sdrCharges: prodItem?.sdrCharges,
                        costingToken: prodItem?.costingToken,
                        margin: prodItem?.margin || ""
                    })

                    prodItem?.productItemVariants?.map((varItem, varIndex) => {
                        const filterVar = productVariant?.filter(
                            (pvar) => pvar.variantId === varItem.variantId
                        );
                        if (filterVar && filterVar?.length > 0) {
                            productVariantsArray.push({
                                sid: (prodIndex * 1) + 1,
                                id: varItem.id,
                                quoteProductItemId: varItem.quoteProductItemId,//addProduct?.length + 1,
                                variantId: varItem?.variantId,
                                variantValue: varItem?.variantValue,
                                inputByUser: filterVar[0].inputByUser,
                            })

                        }
                    })
                })

                if (productVariantsArray?.length > 0) {
                    setvariantsarray(productVariantsArray)
                }
                setAddProduct(addProductArray);
                let specificationarr = []
                editMarkDetails?.data[0]?.productSpecifications?.map((spec, specIndex) => {

                    if ((spec.specificationValueId * 1) > 0) {
                        let specValueId = attributeDetails?.find(item =>
                            item?.productId === editMarkDetails?.data[0]?.productId
                            && item?.attributeId === spec.specificationId
                            && item?.valueItemId === spec.specificationValueId)

                        let specObj = {
                            attributeId: specValueId?.attributeId,
                            attributeName: specValueId?.attributeName,
                            valueId: 0,
                            valueName: specValueId?.valueName,
                            groupName: specValueId?.groupName,
                            productGroupId: editMarkDetails?.data[0]?.groupId,
                            productSubGroupId: editMarkDetails?.data[0]?.productSubGroupId,
                            specialValue: spec?.specialValue,
                        }
                        specificationarr.push(specObj)
                    } else {
                        if (CheckNull(spec?.specialValue) !== "") {
                            let specValueId = attributeDetails?.find(item =>
                                item?.productId === editMarkDetails?.data[0]?.productId
                                && item?.attributeId === spec.specificationId)
                            let specObj = {
                                attributeId: specValueId?.attributeId,
                                attributeName: specValueId?.attributeName,
                                valueId: 0,
                                valueName: "",
                                groupName: specValueId?.groupName,
                                productGroupId: editMarkDetails?.data[0]?.groupId,
                                productSubGroupId: editMarkDetails?.data[0]?.productSubGroupId,
                                specialValue: spec?.specialValue,
                            }
                            specificationarr.push(specObj)
                        }
                    }

                })
                const filterConfig = HandleChangeConfigSetting(specificationarr)
                setConfigSetting(filterConfig);
                const editProductDetails = attributeDetails?.find(
                    item => item?.productId === editMarkDetails?.data[0]?.productId
                );
                if (editProductDetails) {
                    setProductConfig(prev => ({
                        ...prev,
                        productName: {
                            productId: editProductDetails.productId,
                            productName: editProductDetails.productName,
                            productGroupId: editProductDetails.productGroupId,
                            productSubGroupId: editProductDetails.productSubGroupId,
                            imageUrl: editProductDetails.imageUrl || "",
                        }
                    }));
                }

                setLastMatchedProductId(editProductDetails.productId);
                setEditConfig({ status: true, configSetting: filterConfig })
                setHasUnsavedChanges(false);
                setShowUnsavedModal(false);
            }

            setIsEditMarkDetailsLoading(false);
        }

        if (ProductTab?.status !== "editmark" && attributeArray?.length > 0 && configSetting?.length <= 0 && addProduct?.length === 0 && !productConfig?.productName?.productName) {
            let specificationarr = []
            const selectedConfigByAttribute = new Map(
                (ProductTab?.selectedConfiguration || []).map((item) => [
                    item?.attributeName,
                    item?.valueName,
                ])
            );
            const selectedProductId = ProductTab?.id?.id || attributeDetails[0]?.productId;
            attributeArray?.map((filterAttr) => {
                const selectedValueName = selectedConfigByAttribute.get(filterAttr.attributeName);
                const selectedProduct = selectedValueName
                    ? attributeDetails?.find(item =>
                        item?.attributeId === filterAttr.attributeId &&
                        item?.productId === selectedProductId &&
                        item?.valueName === selectedValueName
                    )
                    : null;
                const defaultProduct = selectedProduct || getDefaultAttributeValue(
                    filterAttr.attributeId,
                    selectedProductId
                );
                if (defaultProduct) {
                    specificationarr.push({
                        attributeId: filterAttr.attributeId,
                        attributeName: filterAttr.attributeName,
                        valueId: 0,
                        valueName: defaultProduct?.valueName,
                        groupName: filterAttr?.groupName,
                        productGroupId: defaultProduct?.productGroupId,
                        productSubGroupId: defaultProduct?.productSubGroupId,
                    })
                }
            })
            const filtered = HandleChangeConfigSetting(specificationarr);
            setConfigSetting(filtered);
            setEditConfig({ status: true, configSetting: filtered })
            setHasUnsavedChanges(false);
            setShowUnsavedModal(false);
        }
    }, [editMarkDetails, productVariant, attributeDetails, attributeArray])

    const HandleChangeConfigSetting = (specificationarr) => {
        if (!specificationarr || specificationarr.length === 0) return [];

        const hasBankOfBlateNoValue = specificationarr.some(
            (item) => item.attributeId === urls.BANK_OF_BLATE && item.valueName === urls.BANK_OF_BLATE_NO_VALUE
        );

        const hasPlenumNoneValue = specificationarr.some(
            (item) => item.attributeId === urls.PLENUM && item.valueName === urls.PLENUM_NONE_VALUE
        );

        const hasPlenumWithoutInsulation = specificationarr.some(
            (item) => item.attributeId === urls.PLENUM && item.valueName === urls.PLENUM_WITHOUT_INSULATION_VALUE
        );

        return specificationarr.filter(
            (item) =>
                !(
                    (hasBankOfBlateNoValue && urls.BANK_OFF_BLATE_ARRAY.includes(item.attributeId)) ||
                    (hasPlenumNoneValue && urls.PLENUM_ATTRIBUTES_WITH_ARRAY.includes(item.attributeId)) ||
                    (hasPlenumWithoutInsulation && urls.PLENUM_ATTRIBUTES_WITHOUT_NOTALLOWEDARRAY.includes(item.attributeId))
                )
        );
    };

    const getDefaultAttributeValue = (attributeId, productId) => {
        const candidateValues = (attributeDetails ?? [])
            .filter(
                (item) =>
                    item?.attributeId === attributeId &&
                    item?.productId === productId &&
                    item?.valueName
            )
            .sort((a, b) => (a?.sequenceValue || 0) - (b?.sequenceValue || 0));

        if (!candidateValues.length) return null;

        return (
            candidateValues.find((item) => Number(item?.sequenceValue) === 1) ??
            candidateValues[0]
        );
    };


    useEffect(() => {
        const matchedId = productConfig?.productName?.productId;

        if (!matchedId) return;
        if (editMarkDetails?.data?.length) return;

        const isFirstMatch = lastMatchedProductId === null;
        const productChanged = !isFirstMatch && matchedId !== lastMatchedProductId;
        if ((isFirstMatch && addProduct?.length === 0 && productVariant?.length > 0 && configSetting?.length > 0) || productChanged) {
            setAddProduct([]);
            setvariantsarray([]);
            setLastMatchedProductId(matchedId);
            AddProduct(false);
            setHasUnsavedChanges(false);
            setShowUnsavedModal(false);
        }
    }, [productConfig?.productName?.productId, productVariant, configSetting])


    useEffect(() => {
        if (productSubmit?.markSubmit === true) {
            if (ValidConfiguration() === "error") return;
            if (ValidEntry() === "error") return;
            if (CheckNull(values?.id) !== "") {
                const valuesCopy = values;
                valuesCopy.modifiedBy = localStorage.getItem("authidentity")
                UpdateEntry(
                    "quotation",
                    valuesCopy,
                    setCreateMsg,
                    "success",
                    "Failed to update quotation"
                );
            }
            else {
                CreateEntry(
                    "quotation",
                    values,
                    setCreateMsg,
                    "success",
                    "Failed to create quotation"
                );
            }
        }
    }, [productSubmit])

    useEffect(() => {
        if (CheckNull(createMsg?.message) == "success") {
            CreateMark();
        }
    }, [createMsg])

    const CreateMark = () => {
        if (ValidConfiguration() === "error") return;
        if (ValidEntry() === "error") return;
        let submitdata = [];
        if (productSubmit?.markSubmit === true) {
            let QuantityValue = 0
            let listPrice = 0
            let netPrice = 0

            addProduct.map((productitem, productindex) => {
                let list = variantsArray.filter(function (data) {
                    return data.sid === productitem?.sid
                })
                const variantslist = list?.map((element, index) => {
                    if (urls.QUANTITY_CONSTANT.includes(element?.variantId)) {
                        QuantityValue = (QuantityValue * 1) + (element?.variantValue * 1)
                    }
                    if (urls.NET_LIST_PRICE_CONSTANT.includes(element?.variantId)) listPrice = (listPrice * 1) + (element?.variantValue * 1)
                    if (urls.NET_UNIT_PRICE_CONSTANT.includes(element?.variantId)) netPrice = (netPrice * 1) + (element?.variantValue * 1)
                    let variantsdata = {
                        id: element.id,
                        quoteProductItemId: element.quoteProductItemId,
                        variantId: element.variantId,
                        variantValue: element.variantValue
                    }
                    return variantsdata;
                }
                );
                const filterVarList = variantsArray?.filter(
                    (pvar) => pvar.variantId === urls?.LIST_PRICE_CONSTANT[0]
                );
                const filterVarUnit = variantsArray?.filter(
                    (pvar) => pvar.variantId === urls?.UNIT_PRICE_CONSTANT[0]
                );
                let params = {
                    id: productitem?.id,
                    quoteProductId: productitem?.quoteProductId,
                    notes: productitem?.notes,
                    specialDesignRequest: productitem?.specialDesignRequest,
                    sdrCharges: productitem?.sdrCharges,
                    costingToken: productitem?.costingToken,
                    margin: (productitem?.margin && !isNaN(Number(productitem.margin))) ? Number(productitem.margin) : 0,
                    productItemVariants: variantslist
                }
                submitdata.push(params)
            })


            const normalize = (v) => (v ?? "").toString().trim().toLowerCase();
            const configToSave =
                (configSetting && configSetting.length > 0)
                    ? configSetting
                    : (productConfig?.configuration ?? []);

            let configItem = []
            configToSave?.map((config, index) => {
                let specValueId = attributeDetails?.find(item =>
                    item?.productId === productConfig?.productName?.productId
                    && item?.attributeId === config?.attributeId
                    && normalize(item?.valueName) === normalize(config?.valueName)
                )
                configItem.push({
                    quoteProductId: 0,
                    specificationId: config?.attributeId,
                    specificationValueId: specValueId?.valueItemId || 0,
                    SpecialValue: config?.specialValue || "",
                    SpecialCharges: 0
                })

            })
            if (editMarkDetails?.data?.length > 0) {
                if (submitdata?.length > 0) {
                    let variantsubmitdata = {
                        id: editMarkDetails?.data[0]?.id,
                        quotationId: editMarkDetails?.data[0]?.quotationId,
                        markName: editMarkDetails?.data[0]?.markName,
                        productId: productConfig?.productName?.productId,
                        quantity: QuantityValue,
                        listPrice: 0,
                        margin: editMarkDetails?.data?.[0]?.margin ?? 0,
                        salesMargin: 0,
                        sellingPrice: 0,
                        totalDdp: editMarkDetails?.data[0]?.totalDdp,
                        productItems: submitdata,
                        productSpecifications: configItem
                    }
                    UpdateEntry("updateproductmark", variantsubmitdata, setMarkCreateMessage, "Product updated successfully", "Failed to update product")
                }

            } else {
                if (submitdata?.length > 0) {
                    let variantsubmitdata = {
                        id: 0,
                        quotationId: CheckNull(values?.id) !== "" ? values?.id : createMsg?.successData?.id,
                        markName: "mark" + ((values?.products?.length * 1) + 1),
                        productId: productConfig?.productName?.productId,
                        quantity: QuantityValue,
                        listPrice: 0,
                        margin: 0,
                        salesMargin: 0,
                        sellingPrice: 0,
                        totalDdp: netPrice,
                        productItems: submitdata,
                        productSpecifications: configItem,
                    }
                    CreateEntry("productmark", variantsubmitdata, setMarkCreateMessage, "Product submitted successfully", "Failed to submit product")
                }
            }
        }
    }

    const openSaveSuccessModal = () => {
        if (showUnsavedModal) {
            setPendingSuccessModal(true);
            setShowUnsavedModal(false);
            return;
        }

        setSuccessShow(true);
    };

    const handleUnsavedModalExited = () => {
        if (pendingSuccessModal) {
            setPendingSuccessModal(false);
            setSuccessShow(true);
        }
    };

    useEffect(() => {
        if (markCreateMessage?.message.includes("successfully") === true) {
            GetOne("quotation", { id: markCreateMessage?.successData?.quotationId }, setQuoteMsg)
            openSaveSuccessModal();
            setCreateMsg(null);
            markWorkspaceSnapshot();
            setHasUnsavedChanges(false);
        }
    }, [markCreateMessage])

    useEffect(() => {
        if (quoteMsg?.message === "success") {
            setValues(quoteMsg?.data)
        }

    }, [quoteMsg])

    useEffect(() => {
        if (CheckNull(quoteDetails?.message) == "success") {
            openSaveSuccessModal();
            setCreateMsg(null);
        }
    }, [quoteDetails])

    const BackTab = () => {
        if (hasUnsavedChanges) {
            setShowUnsavedModal(true);
            setPendingNavigation(true);
            return;
        }

        proceedNavigation();
    };

    const proceedNavigation = () => {
        if (ProductTab?.status === "editmark") {
            setProductSubmit({ markRedirect: false, markSubmit: false });
            setProductTab({ tab: "ProductList", id: 0 });
        } else {
            setProductSubmit({ markRedirect: false, markSubmit: false });
            setProductTab({
                tab: ProductTab?.redirectTab,
                productSubCategoryId: ProductTab?.productSubCategoryId,
                subCategoryId: ProductTab?.subCategoryId,
                title: ProductTab?.title,
            });
        }
    };

    const handleUnsavedConfirm = () => {
        SaveProductMarkAdd();
        setHasUnsavedChanges(false);
        setShowUnsavedModal(false);
        if (pendingNavigation) {
            proceedNavigation();
        }
    };

    useEffect(() => {
        if (errorMessage) {
            setShowUnsavedModal(false);
            setPendingNavigation(false);
        }
    }, [errorMessage]);

    const CopyNewEntry = (copyItem) => {
        if (ValidConfiguration() === "error") return;
        if (ValidEntry() === "error") return;

        const list = [...addProduct];
        const filterProduct = list.filter(x => x.sid === copyItem.sid);
        const filterVarList = variantsArray?.filter(
            (pvar) => pvar.variantId === urls?.LIST_PRICE_CONSTANT[0]
        );
        const filterVarUnit = variantsArray?.filter(
            (pvar) => pvar.variantId === urls?.UNIT_PRICE_CONSTANT[0]
        );
        let uniqueNumber = Date.now() + Math.floor(Math.random() * 1000);
        setAddProduct(prev => [...prev, {
            sid: uniqueNumber,
            id: 0,
            quoteProductId: 0,
            notes: filterProduct[0].notes,
            specialDesignRequest: filterProduct[0]?.specialDesignRequest,
            sdrCharges: filterProduct[0]?.sdrCharges,
            costingToken: filterProduct[0]?.costingToken,
            margin: filterProduct[0]?.margin || ""
        }])

        const filterVariants = variantsArray.filter(item => item.sid === copyItem.sid)
        if (filterVariants) {
            if (filterVariants?.length > 0) {
                let productVariantsArray = []
                filterVariants?.map((item, index) => {
                    productVariantsArray.push({
                        sid: uniqueNumber,
                        id: 0,
                        quoteProductItemId: 0,
                        variantId: item?.variantId,
                        variantValue: item?.variantValue,
                        inputByUser: item?.inputByUser
                    })
                })
                if (productVariantsArray?.length > 0) {
                    setvariantsarray(prev => [...prev, ...productVariantsArray])
                }
            }
        }
    }

    const InsertLineAbove = (item) => {
        insertSizeRowAt(item?.sid, "above");
    };

    const InsertLineBelow = (item) => {
        insertSizeRowAt(item?.sid, "below");
    };

    useEffect(() => {
        if (!invalidUnitPrice || invalidUnitPrice.length === 0) return;

        const stillInvalid = invalidUnitPrice.filter((entry) => {
            const unitPriceItem = variantsArray.find(
                (v) => v.sid === entry.sid && urls?.UNIT_PRICE_CONSTANT?.includes(v.variantId)
            );
            return CheckNull(unitPriceItem?.variantValue) <= 0;
        });

        if (stillInvalid.length !== invalidUnitPrice.length) {
            setInvalidUnitPrice(stillInvalid);
        }
    }, [variantsArray])

    useEffect(() => {
        if (!requiredFieldError || requiredFieldError.length === 0) return;

        const stillInvalid = requiredFieldError.filter((entry) => {
            const currentItem = variantsArray.find(
                (v) => v.sid === entry.sid && v.variantId === entry.variantId
            );
            return CheckNull(currentItem?.variantValue) === "";
        });

        if (stillInvalid.length !== requiredFieldError.length) {
            setRequiredFieldError(stillInvalid);
        }
    }, [variantsArray])

    useEffect(() => {
        setSelectedSizeRowSids((prev) => prev.filter((sid) => addProduct.some((item) => item?.sid === sid)));
    }, [addProduct]);

    useEffect(() => {
        pruneExcessBlankRows();
    }, [addProduct, variantsArray]);

    const creatingRowRef = useRef(false);
    const getVariantTemplate = () =>
        productConfigVariant?.length > 0 ? productConfigVariant : productVariant;

    const createBlankSizeRow = (sid) => ({
        sid,
        id: 0,
        quoteProductId: 0,
        notes: "",
        specialDesignRequest: "",
        sdrCharges: "",
        costingToken: "",
        margin: "",
    });

    const createBlankSizeRowVariants = (sid) =>
        (getVariantTemplate() || []).map((item) => ({
            sid,
            id: 0,
            quoteProductItemId: 0,
            variantId: item?.variantId,
            variantValue: "",
            inputByUser: item?.inputByUser,
        }));

    const insertSizeRowAt = (targetSid, position = "below") => {
        const targetIndex = addProduct.findIndex((row) => String(row?.sid) === String(targetSid));
        if (targetIndex === -1) return null;

        const uniqueNumber = Date.now() + Math.floor(Math.random() * 1000);
        const insertIndex = position === "above" ? targetIndex : targetIndex + 1;
        const newRow = createBlankSizeRow(uniqueNumber);
        const newRowVariants = createBlankSizeRowVariants(uniqueNumber);

        setAddProduct((prev) => {
            const nextRows = [...prev];
            nextRows.splice(insertIndex, 0, newRow);
            return nextRows;
        });

        if (newRowVariants.length > 0) {
            setvariantsarray((prev) => [...prev, ...newRowVariants]);
        }

        setHasUnsavedChanges(true);
        return uniqueNumber;
    };

    const AddProduct = (markDirty = true) => {
        const uniqueNumber = Date.now() + Math.floor(Math.random() * 1000);
        setAddProduct((prev) => [...prev, createBlankSizeRow(uniqueNumber)]);

        const productVariantsArray = createBlankSizeRowVariants(uniqueNumber);
        if (productVariantsArray.length > 0) {
            setvariantsarray((prev) => [...prev, ...productVariantsArray]);
        }

        if (markDirty) {
            setHasUnsavedChanges(true);
        }
        return uniqueNumber;
    }
    const openedRowRef = useRef(new Set());
    const HandleProductOnchange = (e, item) => {
        if (ValidConfiguration() === "error") return;

        // react-select (END_CAPS, WIDTH, HEIGHT) passes {label, value} directly.
        const rawValue = e?.target ? e.target.value : (e?.value ?? "");

        if (urls?.NUMBER_VALIDATION_ARRAY.includes(item?.variantId))
            if (/^\d*$/.test(rawValue) === false) return;

        if (urls?.QUANTITY_CONSTANT.includes(item?.variantId)) {
            if (rawValue !== "" && (parseInt(rawValue) === 0 || rawValue === "0")) return;
        }

        const index = variantsArray.findIndex(i => i.sid === item.sid && i.variantId === item.variantId)
        if (index === -1) return;
        // scheduleFocusNextRow(item.sid);

        const isWidthField = (item?.variantName || "").toLowerCase().includes("width");
        const previousValue = variantsArray[index]?.variantValue ?? "";

        setvariantsarray(prev => {
            const newArr = [...prev];
            newArr[index] = {
                ...prev[index],
                variantValue: rawValue
            };
            return newArr;
        });

        if (previousValue === "" && rawValue !== "") {
            ensureNextRowExists(item.sid);
        }
        setvariantsarray(prev => {
            const newArr = [...prev];
            newArr[index] = {
                ...prev[index],
                variantValue: rawValue
            };

            // Width changed: check if sibling Height value is still valid, else clear it
            if (isWidthField && Array.isArray(combinations) && combinations.length > 0) {
                const heightConfig = productConfigVariant.find(
                    (v) => (v?.variantName || "").toLowerCase().includes("height")
                );
                if (heightConfig) {
                    const heightIndex = newArr.findIndex(
                        (v) => v.sid === item.sid && v.variantId === heightConfig.variantId
                    );
                    if (heightIndex !== -1) {
                        const currentHeightValue = newArr[heightIndex].variantValue;
                        if (currentHeightValue) {
                            const isStillValid = combinations.some((combo) => {
                                const widthMatch = combo?.options?.some(
                                    (opt) => opt?.variantId === item?.variantId && opt?.value === rawValue
                                );
                                const heightMatch = combo?.options?.some(
                                    (opt) => opt?.variantId === heightConfig.variantId && opt?.value === currentHeightValue
                                );
                                return widthMatch && heightMatch;
                            });
                            if (!isStillValid) {
                                newArr[heightIndex] = { ...newArr[heightIndex], variantValue: "" };
                            }
                        }
                    }
                }
            }

            return newArr;
        })
    }

    const ValidEntry = () => {
        let nominalneckarr = variantsArray.filter((item) => (CheckNull(item.variantValue) === "") && urls.VALIDATION_VARIANT_ARRAY.includes(item.variantId))
        let unitPricearr = variantsArray.filter((item) => (CheckNull(item.variantValue) <= 0) && urls.UNIT_PRICE_CONSTANT.includes(item.variantId))
        let variant = nominalneckarr.map(item => item.variantId);
        let variantnamearr = productConfigVariant.filter((item) => variant.includes(item.variantId))
        let strvariantname = variantnamearr.map(item => item.variantName).join(",");

        if (nominalneckarr?.length > 0) {
            let index = (((addProduct?.findIndex(item => item?.sid === nominalneckarr[0].sid)) * 1) + 1)
            setErrorMessage("Line No :" + index + " , Please fill the " + strvariantname + " .");
            setRequiredFieldError(nominalneckarr);
            setProductSubmit({ markRedirect: false, markSubmit: false });
            return "error";
        } else if (unitPricearr?.length > 0) {
            setInvalidUnitPrice(unitPricearr)
            setRequiredFieldError([]);
            let index = (((addProduct?.findIndex(item => item?.sid === unitPricearr[0].sid)) * 1) + 1)
            setErrorMessage("Line No :" + index + " , Unit net price value must be greater than the zero .");
            setProductSubmit({ markRedirect: false, markSubmit: false });
            return "error";
        } else if (marginRangeError?.length > 0) {
            let index = (((addProduct?.findIndex(item => item?.sid === marginRangeError[0].sid)) * 1) + 1)
            setErrorMessage("Line No :" + index + " , " + marginRangeError[0]?.message);
            setProductSubmit({ markRedirect: false, markSubmit: false });
            return "error";
        }

        setErrorMessage(null);
        setInvalidUnitPrice(null);
        setRequiredFieldError([]);
    }
    const ValidConfiguration = () => {
        if (CheckNull(productConfig?.productName?.productName) === "") {
            setErrorMessage("There is no product match with your configuration");
            setProductSubmit({ markRedirect: false, markSubmit: false });
            return "error";
        }
        setErrorMessage(null);
    }

    const HandleOnChangenotes = (e, productitem, isClear) => {
        const index = addProduct.findIndex(i => i.sid === productitem.sid)
        if (index === -1) return;
        setAddProduct(prev => {
            const newArr = [...prev];
            newArr[index] = { ...prev[index], notes: isClear === true ? "" : e.target.value }
            return newArr
        })
    }

    const HandleOnChangeSDR = (e, productitem) => {
        const index = addProduct.findIndex(i => i.sid === productitem.sid)
        if (index === -1) return;
        setAddProduct(prev => {
            const newArr = [...prev];
            newArr[index] = { ...prev[index], [e.target.name]: e.target.value }
            return newArr
        })
    }

    const HandleOnChangeSDRClear = (e, productitem) => {
        const index = addProduct.findIndex(i => i.sid === productitem.sid)
        if (index === -1) return;
        setAddProduct(prev => {
            const newArr = [...prev];
            newArr[index] = { ...prev[index], specialDesignRequest: "", sdrCharges: "" }
            return newArr
        })
    }

    const deleteProductsBySid = (sids = []) => {
        const sidSet = new Set(sids);
        const nextRows = addProduct.filter((item) => !sidSet.has(item?.sid));

        setAddProduct(nextRows);
        setvariantsarray((prev) => prev.filter((item) => !sidSet.has(item?.sid)));
        setSelectedSizeRowSids((prev) => prev.filter((sid) => !sidSet.has(sid)));

        if (nextRows.length === 0) {
            setDeleteProduct(true);
        }
    };

    const DeleteProduct = (delItem) => {
        deleteProductsBySid([delItem?.sid]);
    }

    const ToggleSizeRowSelection = (sid) => {
        setSelectedSizeRowSids((prev) =>
            prev.includes(sid) ? prev.filter((item) => item !== sid) : [...prev, sid]
        );
    };

    const ToggleAllSizeRowSelection = () => {
        if (selectedSizeRowSids.length === addProduct.length) {
            setSelectedSizeRowSids([]);
            return;
        }

        setSelectedSizeRowSids(addProduct.map((item) => item?.sid));
    };

    const BulkDeleteSelectedRows = () => {
        if (!selectedSizeRowSids.length) return;
        deleteProductsBySid(selectedSizeRowSids);
    }

    useEffect(() => {
        if (deleteProduct === true && addProduct?.length === 0 && variantsArray?.length === 0) {
            AddProduct(false);
            setDeleteProduct(false);
        }
    }, [addProduct])

    const SuccessDoneClick = () => {
        setSuccessShow(false); setMarkCreateMessage(null);
        if (productSubmit?.markRedirect === true) {
            setProductSubmit({ markRedirect: false, markSubmit: false });
            setProductTab({ tab: "ProductList", id: 0, status: "updated" });
        }
    }

    const openedNextRowRef = useRef(new Set());
    const ensureNextRowExists = (currentSid) => {
        if (openedRowRef.current.has(currentSid)) return;

        const rows = addProductRef.current || [];
        const currentIndex = rows.findIndex(
            (r) => String(r.sid) === String(currentSid)
        );

        if (currentIndex === rows.length - 1) {
            AddProduct();
        }

        openedRowRef.current.add(currentSid);
    };
    const openNextRowOnce = (sid) => {
        if (openedNextRowRef.current.has(sid)) {
            return;
        }

        openedNextRowRef.current.add(sid);
        ensureNextRowExists(sid);
    };

    const HandleProductonfocusout = (item, productindex) => {
        if (urls?.QUANTITY_CONSTANT.includes(item?.variantId)) {
            const currentValue = variantsArray.find(
                (i) => i.sid === item.sid && i.variantId === item.variantId
            )?.variantValue;

            if (
                currentValue === "0" ||
                currentValue === "" ||
                parseInt(currentValue) === 0
            ) {
                const index = variantsArray.findIndex(
                    (i) => i.sid === item.sid && i.variantId === item.variantId
                );

                if (index !== -1) {
                    setvariantsarray((prev) => {
                        const newArr = [...prev];
                        newArr[index] = {
                            ...prev[index],
                            variantValue: "",
                        };
                        return newArr;
                    });
                }

                return;
            }
        }

        // Existing logic
        HandleProductOnChange(item, productindex);

        openNextRowOnce(item.sid);
    };
    const getRowEditableCells = (rowElement) =>
        Array.from(rowElement.querySelectorAll('[data-size-editable="true"]'));

    const focusFirstEditableInRow = (rowSid) => {
        const rowElement = document.querySelector(`tr[data-size-row-sid="${rowSid}"]`);
        if (!rowElement) return false;

        const editableCell = getRowEditableCells(rowElement)[0];
        if (!editableCell) return false;

        const input = editableCell.querySelector(
            'input:not([type="hidden"]):not([type="checkbox"]):not([disabled]), textarea:not([disabled]), select:not([disabled]), [role="combobox"], .size-select__control'
        );

        const target = input || editableCell;
        if (typeof target.focus !== "function") return false;

        target.focus({ preventScroll: true });
        if (typeof target.select === "function" && target.tagName === "INPUT") {
            target.select();
        }
        return true;
    };

    const scheduleFocusNextRow = (currentRowSid) => {
        if (pendingSizeFocusFrameRef.current) {
            cancelAnimationFrame(pendingSizeFocusFrameRef.current);
        }

        const request = {
            currentRowSid: String(currentRowSid),
            attempts: 0,
            createdRowSid: null,
        };

        pendingSizeFocusRef.current = request;

        const tick = () => {
            const pending = pendingSizeFocusRef.current;
            if (!pending || pending !== request) return;

            const rows = addProductRef.current || [];

            const currentIndex = rows.findIndex(
                row => String(row.sid) === pending.currentRowSid
            );

            const nextRowSid =
                currentIndex >= 0
                    ? rows[currentIndex + 1]?.sid
                    : null;

            if (
                currentIndex === rows.length - 1 &&
                !nextRowSid &&
                !pending.createdRowSid
            ) {
                pending.createdRowSid = AddProduct();
            }

            const targetRowSid = nextRowSid || pending.createdRowSid;

            if (targetRowSid && focusFirstEditableInRow(targetRowSid)) {
                pendingSizeFocusRef.current = null;
                pendingSizeFocusFrameRef.current = null;
                return;
            }

            if (pending.attempts < 30) {
                pending.attempts++;
                pendingSizeFocusFrameRef.current =
                    requestAnimationFrame(tick);
                return;
            }

            pendingSizeFocusRef.current = null;
            pendingSizeFocusFrameRef.current = null;
        };

        pendingSizeFocusFrameRef.current =
            requestAnimationFrame(tick);
    };

    const handleKeyDown = (event) => {
        setLastKey(event.key);

        if (event.key !== "Tab" || event.shiftKey) return;

        const currentRow = event.currentTarget?.closest("tr[data-size-row-sid]");
        if (!currentRow) return;

        const currentCell = event.currentTarget?.closest('[data-size-editable="true"]');
        if (!currentCell) return;

        const editableCells = getRowEditableCells(currentRow);
        const lastEditableCell = editableCells[editableCells.length - 1];
        if (currentCell !== lastEditableCell) return;

        event.preventDefault();
        scheduleFocusNextRow(currentRow.dataset.sizeRowSid);
    };

    const closeActionMenu = () => {
        setActionMenuOpen({});
        setSDROpen({});
    };

    const toggleActionMenu = (event, sid) => {
        if (actionMenuOpen?.show === "show" && actionMenuOpen?.showid === sid) {
            closeActionMenu();
            return;
        }

        const triggerRect = event.currentTarget.getBoundingClientRect();
        const gridScrollRect = event.currentTarget
            .closest(".product-size-grid-scroll")
            ?.getBoundingClientRect();
        const menuWidth = 130;
        const menuHeight = 110;
        const viewportPadding = 8;
        const menuGap = 4;
        const boundsTop = Math.max(viewportPadding, gridScrollRect?.top ?? viewportPadding);
        const boundsBottom = Math.min(
            window.innerHeight - viewportPadding,
            gridScrollRect?.bottom ?? window.innerHeight - viewportPadding
        );
        const boundsLeft = Math.max(viewportPadding, gridScrollRect?.left ?? viewportPadding);
        const boundsRight = Math.min(
            window.innerWidth - viewportPadding,
            gridScrollRect?.right ?? window.innerWidth - viewportPadding
        );

        const centeredTop = triggerRect.top + (triggerRect.height / 2) - (menuHeight / 2);
        const top = Math.min(
            boundsBottom - menuHeight,
            Math.max(boundsTop, centeredTop)
        );
        const left = Math.min(
            boundsRight - menuWidth,
            Math.max(boundsLeft, triggerRect.left - menuWidth - menuGap)
        );

        setActionMenuPosition({ top, left });
        setSDROpen({});
        setActionMenuOpen({
            show: "show",
            showid: sid
        });
    };

    useEffect(() => {
        if (actionMenuOpen?.show !== "show") return;
        const handleOutsideClick = (e) => {
            if (!e.target.closest(".action-cell") && !e.target.closest(".quote-action-menu")) {
                closeActionMenu();
            }
        };
        const handleViewportChange = () => closeActionMenu();
        document.addEventListener("click", handleOutsideClick);
        window.addEventListener("resize", handleViewportChange);
        window.addEventListener("scroll", handleViewportChange, true);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
            window.removeEventListener("resize", handleViewportChange);
            window.removeEventListener("scroll", handleViewportChange, true);
        };
    }, [actionMenuOpen]);

    const RecalculatePrice = (e) => {
        setProductConfig({ ...productConfig, configuration: configSetting, productName: productName });
        setRecalculateLoading(true);
        setRecalculate(true)
        setRecalculateModalShow(false)
    }

    useEffect(() => {
        if (recalculate === true) {
            const apiCalls = addProduct.map((productItem, productIndex) =>
                Promise.resolve(HandleProductOnChange({ sid: productItem?.sid }, productIndex))
            );
            Promise.all(apiCalls)
                .then(() => {
                    setRecalculateLoading(false);
                    setRecalculate(false);
                })
                .catch((error) => {
                    console.error("Error processing products:", error);
                });
        }
    }, [recalculate, productConfig?.productName])

    const HandleCancelRecalculate = () => {
        setRecalculateModalShow(false)
        setConfigSetting(productConfig?.configuration)
    }

    const hasEnteredProductValues = () =>
        (variantsArray ?? []).some(
            (item) =>
                CheckNull(item?.variantValue) !== "" &&
                !urls?.LIST_PRICE_CONSTANT?.includes(item?.variantId) &&
                !urls?.NET_LIST_PRICE_CONSTANT?.includes(item?.variantId) &&
                !urls?.UNIT_PRICE_CONSTANT?.includes(item?.variantId) &&
                !urls?.NET_UNIT_PRICE_CONSTANT?.includes(item?.variantId)
        );

    const HandleConfigurationChange = () => {
        setHasUnsavedChanges(true);
    };

    useEffect(() => {
        const currentConfiguration = productConfig?.configuration ?? [];
        const currentSignature = JSON.stringify(
            [...currentConfiguration]
                .map((item) => ({
                    attributeId: item?.attributeId,
                    valueName: item?.valueName ?? "",
                    specialValue: item?.specialValue ?? "",
                }))
                .sort((a, b) => a.attributeId - b.attributeId)
        );

        if (!currentSignature || currentSignature === "[]") {
            lastConfigurationSignatureRef.current = currentSignature;
            return;
        }

        if (!lastConfigurationSignatureRef.current) {
            lastConfigurationSignatureRef.current = currentSignature;
            return;
        }

        if (lastConfigurationSignatureRef.current === currentSignature) {
            return;
        }

        lastConfigurationSignatureRef.current = currentSignature;

        if (!productConfig?.productName?.productId) return;
        if (!addProduct?.length) return;
        if (!hasEnteredProductValues()) return;

        const apiCalls = addProduct.map((productItem, productIndex) =>
            Promise.resolve(HandleProductOnChange({ sid: productItem?.sid }, productIndex, false))
        );

        Promise.all(apiCalls).catch((error) => {
            console.error("Error recalculating product list price after configuration change:", error);
        });
    }, [productConfig?.configuration, productConfig?.productName?.productId, addProduct, variantsArray]);

    const totalQuantity = variantsArray
        ?.filter((v) => urls?.QUANTITY_CONSTANT?.includes(v?.variantId))
        ?.reduce((sum, v) => sum + (Number(v?.variantValue) || 0), 0) || 0;

    const grandTotalNet = variantsArray
        ?.filter((v) => urls?.NET_UNIT_PRICE_CONSTANT?.includes(v?.variantId))
        ?.reduce((sum, v) => {
            const num = Number(v?.variantValue);
            return sum + (Number.isFinite(num) ? num : 0);
        }, 0) || 0;

    const grandTotalNetDisplay = CurrencyConvertion(grandTotalNet, values?.conversionRate, currencyDetail);
    const [editingId, setEditingId] = useState(null);
    const defaultTab = ProductTab?.status === "editmark" ? "sizes" : "configuration";
    const [activeTab, setActiveTab] = useState(defaultTab);
    const tableColumns = useMemo(() => productConfigVariant
        .filter((variant) => !isVariantHidden(variant, productConfig?.configuration))
        .map((variant) => ({ key: variant?.variantId, label: variant?.variantName || "Unnamed column", defaultVisible: true })), [productConfigVariant, productConfig?.configuration]);
    const defaultVisibleColumns = tableColumns.filter((column) => column.defaultVisible).map((column) => column.key);
    const tableColumnSignature = defaultVisibleColumns.join("|");

    useEffect(() => {
        if (!tableColumnSignature) return;

        const storedColumns = readStoredVisibleColumns(columnVisibilityStorageKey);
        const isMatchingWorkspace = storedColumns?.signature === tableColumnSignature;
        const nextVisibleColumns = isMatchingWorkspace
            ? storedColumns.columns.filter((columnKey) => defaultVisibleColumns.includes(columnKey))
            : defaultVisibleColumns;

        if (columnDefaultsSignatureRef.current !== tableColumnSignature) {
            columnDefaultsSignatureRef.current = tableColumnSignature;
            setVisibleColumns(nextVisibleColumns);
            setPendingColumns(nextVisibleColumns);
        }
    }, [tableColumnSignature, columnVisibilityStorageKey, defaultVisibleColumns]);

    useEffect(() => {
        setActiveTab(defaultTab);
    }, [defaultTab]);


    return (<>
        <div className="row product-details-list-row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ProductMarkWorkspaceHeader
                    activeTab={activeTab}
                    defaultTab={defaultTab}
                    onTabChange={setActiveTab}
                    onBack={BackTab}
                    canImport={activeTab === "sizes" && CheckNull(productConfig?.productName?.productName) !== ""}
                    onImport={() => setModalShow(true)}
                    printNode={null}
                    onSave={SaveProductMarkAdd}
                    saving={productSubmit?.markSubmit}
                    selectedSizeCount={selectedSizeRowSids.length}
                    onBulkDeleteSelectedRows={BulkDeleteSelectedRows}
                    availableColumns={activeTab === "sizes" ? tableColumns : []}
                    visibleColumns={visibleColumns}
                    pendingColumns={pendingColumns}
                    onPendingColumnsChange={setPendingColumns}
                    onResetColumns={() => setPendingColumns(defaultVisibleColumns)}
                    onApplyColumns={() => {
                        const nextColumns = pendingColumns.filter((columnKey) =>
                            defaultVisibleColumns.includes(columnKey)
                        );
                        setVisibleColumns(nextColumns);
                        writeStoredVisibleColumns(columnVisibilityStorageKey, {
                            signature: tableColumnSignature,
                            columns: nextColumns,
                        });
                    }}
                />

                <div className="row">

                    <div className={activeTab === "sizes" ? "col-12 product-size-main-col" : "col-xxl-9 col-xl-9 col-lg-8 col-md-12 product-config-main-col"}>
                        <div className="tab-content" id="nav-tabContent">
                            <div className={`tab-pane fade ${activeTab === "configuration" ? "show active" : ""}`} id="nav-configuration" role="tabpanel" aria-labelledby="nav-configuration-tab">
                                <Configuration
                                    inline={true}
                                    setProductTab={setProductTab}
                                    ProductTab={ProductTab}
                                    setProductConfig={setProductConfig}
                                    productConfig={productConfig}
                                    attributes={attributes}
                                    setAttributes={setAttributes}
                                    configSetting={configSetting}
                                    setConfigSetting={setConfigSetting}
                                    setProductConfigVariant={setProductConfigVariant}
                                    productVariant={productVariant}
                                    setvariantsarray={setvariantsarray}
                                    variantsArray={variantsArray}
                                    addProduct={addProduct}
                                    attributeDetails={attributeDetails}
                                    setattributeDetails={setattributeDetails}
                                    setRecalculateModalShow={setRecalculateModalShow}
                                    setProductName={setProductName}
                                    productName={productName}
                                    editConfig={editConfig}
                                    setEditConfig={setEditConfig}
                                    attributeArray={attributeArray}
                                    setAttributeArray={setAttributeArray}
                                    attributeValueArray={attributeValueArray}
                                    setAttributeValueArray={setAttributeValueArray}
                                    groupArray={groupArray}
                                    setGroupArray={setGroupArray}
                                    recalculate={recalculate}
                                    onConfigurationChange={HandleConfigurationChange}
                                />
                            </div>
                            <div className={`tab-pane fade ${activeTab === "sizes" ? "show active" : ""}`} id="nav-sizes" role="tabpanel" aria-labelledby="nav-sizes-tab">
                                <ProductSizeGrid
                                    productConfigVariant={productConfigVariant}
                                    addProduct={addProduct}
                                    variantsArray={variantsArray}
                                    productConfig={productConfig}
                                    configuration={configSetting}
                                    values={values}
                                    currencyDetail={currencyDetail}
                                    optionsMap={optionsMap}
                                    actuatorLocationOptions={actuatorLocationOptions}
                                    actuatorLocationLoading={actuatorLocationLoading}
                                    combinations={combinations}
                                    optionsLoading={optionsLoading}
                                    invalidUnitPrice={invalidUnitPrice}
                                    marginRangeError={marginRangeError}
                                    requiredFieldError={requiredFieldError}
                                    endcaplist={endcaplist}
                                    editingId={editingId}
                                    setEditingId={setEditingId}
                                    actionMenuOpen={actionMenuOpen}
                                    actionMenuPosition={actionMenuPosition}
                                    sdrOpen={sdrOpen}
                                    totalQuantity={totalQuantity}
                                    grandTotalNetDisplay={grandTotalNetDisplay}
                                    onProductChange={HandleProductOnchange}
                                    onProductBlur={HandleProductonfocusout}
                                    onKeyDown={handleKeyDown}
                                    onNotesChange={HandleOnChangenotes}
                                    onToggleActionMenu={toggleActionMenu}
                                    onCloseActionMenu={closeActionMenu}
                                    onInsertLineAbove={InsertLineAbove}
                                    onInsertLineBelow={InsertLineBelow}
                                    onCopy={CopyNewEntry}
                                    onDelete={DeleteProduct}
                                    selectedSizeRowSids={selectedSizeRowSids}
                                    onToggleSizeRowSelection={ToggleSizeRowSelection}
                                    onToggleAllSizeRowSelection={ToggleAllSizeRowSelection}
                                    onBulkDeleteSelectedRows={BulkDeleteSelectedRows}
                                    onToggleSdr={setSDROpen}
                                    onSdrChange={HandleOnChangeSDR}
                                    onSdrClear={HandleOnChangeSDRClear}
                                    onMarginChange={HandleOnChangeMargin}
                                    errorMessage={errorMessage}
                                    isLoading={isEditMarkDetailsLoading}
                                    visibleColumnKeys={visibleColumns}
                                />
                            </div>
                        </div>
                    </div>
                    {activeTab === "configuration" && (
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-12 product-config-preview-col">
                            <ProductPreviewPanel
                                configSetting={configSetting}
                                attributeDetails={attributeDetails}
                                productConfig={productConfig}
                                imageUrl={productConfig?.productName?.imageUrl}
                                modelNo={productConfig?.productName?.productCode}
                                productLabel={productConfig?.productName?.productName}
                                productCategory={productConfig?.productName?.productCategory}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
        <PriceRecalculate modalShow={recalculateModalShow} setModalShow={setRecalculateModalShow} RecalculatePrice={RecalculatePrice} HandleCancelRecalculate={HandleCancelRecalculate} />
        <ProductImportFile
            modalShow={modalShow}
            setModalShow={setModalShow}
            productVariant={productVariant}
            setAddProduct={setAddProduct}
            addProduct={addProduct}
            productConfigVariant={productConfigVariant}
            variantsArray={variantsArray}
            setvariantsarray={setvariantsarray}
            HandleProductOnChange={HandleProductOnChange}
            setRecalculateLoading={setRecalculateLoading}
            productConfig={productConfig}
            endcaplist={endcaplist}
        />
        <SaveSuccessModel show={successshow} createMsg={markCreateMessage} setShow={setSuccessShow} SuccessDoneClick={SuccessDoneClick} />
        <UnSaveModel
            show={showUnsavedModal}
            setShow={setShowUnsavedModal}
            onExited={handleUnsavedModalExited}
            createMsg={{ message: "You want to save this changes" }}
            title="Unsaved Changes"
            buttonText="Save & Continue"
            SuccessDoneClick={handleUnsavedConfirm}
            SaveProductMarkAdd={SaveProductMarkAdd}
        />
        {recalculateLoading && <Loader />}
    </>
    )
}
